import {DynaCMSClient} from "../../../packages/dyna-cms-client/DynaCMSClient";
import {dynaCMSConfig} from "../../../settings/dynaCMSConfig";

export const dynaCMSClient = new DynaCMSClient(dynaCMSConfig);
